(function () {
  'use strict';

  function ukNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    }).formatToParts(new Date()).reduce(function (a, x) {
      a[x.type] = x.value; return a;
    }, {});
    return {
      y: +parts.year, m: +parts.month, d: +parts.day,
      h: +parts.hour, mi: +parts.minute, s: +parts.second
    };
  }

  // Get the next working day (Mon-Fri) from a given UK date, skipping weekends.
  function nextWorkingDay(n) {
    var d = new Date(Date.UTC(n.y, n.m - 1, n.d));
    do {
      d.setUTCDate(d.getUTCDate() + 1);
    } while (d.getUTCDay() === 0 || d.getUTCDay() === 6);
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return days[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + months[d.getUTCMonth()];
  }

  function render() {
    // Countdown to 2pm UK cutoff
    document.querySelectorAll('.ts-pdp-cro__countdown').forEach(function (cd) {
      var prefix = cd.querySelector('[data-ts-countdown-prefix]');
      var value = cd.querySelector('[data-ts-countdown-value]');
      var suffix = cd.querySelector('[data-ts-countdown-suffix]');
      if (!value) return;

      var cutoff = parseInt(cd.getAttribute('data-ts-cutoff-hour'), 10) || 14;
      var n = ukNow();
      var secondsUntilCutoff = ((cutoff - n.h) * 3600) - (n.mi * 60) - n.s;
      var dow = new Date(Date.UTC(n.y, n.m - 1, n.d)).getUTCDay(); // 0=Sun..6=Sat

      var isWeekend = (dow === 0 || dow === 6);
      var isBeforeCutoff = (!isWeekend && secondsUntilCutoff > 0);

      if (isBeforeCutoff) {
        cd.setAttribute('data-ts-state', 'before');
        var h = Math.floor(secondsUntilCutoff / 3600);
        var m = Math.floor((secondsUntilCutoff % 3600) / 60);
        if (prefix) prefix.textContent = 'Order in ';
        value.textContent = h + 'h ' + (m < 10 ? '0' + m : m) + 'm';
        if (suffix) suffix.textContent = ' for same-day dispatch';
      } else {
        cd.setAttribute('data-ts-state', 'after');
        if (prefix) prefix.textContent = 'Next dispatch: ';
        value.textContent = nextWorkingDay(n);
        if (suffix) suffix.textContent = '';
      }
    });

    // Stock indicator
    document.querySelectorAll('[data-ts-stock-available]').forEach(function (el) {
      var v = el.getAttribute('data-ts-stock-available');
      var lbl = el.querySelector('[data-ts-stock-label]');
      if (v === 'false' || v === 'null' || v === '0' || v === '') {
        el.classList.remove('ts-pdp-cro__stock--in');
        el.classList.add('ts-pdp-cro__stock--out');
        if (lbl) lbl.textContent = 'Temporarily out of stock';
      }
    });
  }

  function init() {
    render();
    setInterval(render, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
